import { GetShipmentsFilterContainerSizesItem } from '@uturn/api/v2';
import { AccordionContent, AccordionTrigger, Checkbox } from '@uturn/ui-kit';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { FilterContext } from './context';

export function ContainerTypeFilter() {
	const { filters, setFilters } = useContext(FilterContext);
	const { t } = useTranslation();

	const options = [
		{
			label: t('general.container-sizes.SIZE_20FT', '20FT'),
			value: GetShipmentsFilterContainerSizesItem.SIZE_20FT,
		},
		{
			label: t('general.container-sizes.SIZE_30FT', '30FT'),
			value: GetShipmentsFilterContainerSizesItem.SIZE_30FT,
		},
		{
			label: t('general.container-sizes.SIZE_40FT', '40FT'),
			value: GetShipmentsFilterContainerSizesItem.SIZE_40FT,
		},
		{
			label: t('general.container-sizes.SIZE_45FT', '45FT'),
			value: GetShipmentsFilterContainerSizesItem.SIZE_45FT,
		},
		{
			label: t('general.container-sizes.other', 'Other'),
			value: GetShipmentsFilterContainerSizesItem.OTHER,
		},
	];

	const types =
		typeof filters['filter.containerSizes'] === 'string'
			? [filters['filter.containerSizes']]
			: (filters['filter.containerSizes'] ?? []);

	const handleOnChange = (
		selectedStatus: GetShipmentsFilterContainerSizesItem,
		select: boolean,
	) => {
		if (select) {
			setFilters({ 'filter.containerSizes': [...types, selectedStatus] });
		} else {
			setFilters({
				'filter.containerSizes': types.filter((s) => s !== selectedStatus),
			});
		}
	};

	return (
		<>
			<AccordionTrigger>
				{t('pages.shipments.filters.containerSize.title', 'Container size')}
			</AccordionTrigger>
			<AccordionContent>
				<div className="grid gap-1">
					{options.map((s) => (
						<div key={s.value} className="flex items-center space-x-2">
							<Checkbox
								checked={types.findIndex((value) => value === s.value) !== -1}
								onCheckedChange={(e: boolean) => handleOnChange(s.value, e)}
								id={s.value}
							/>
							<label
								htmlFor={s.value}
								className="cursor-pointer text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
							>
								{s.label}
							</label>
						</div>
					))}
				</div>
			</AccordionContent>
		</>
	);
}
